import React from 'react';
import { IBlockData } from '../../../typings';
import { BasicType } from '../../../constants';
import { getImg } from '../../../utils/getImg';
import { BasicBlock } from '../../../components/BasicBlock';
import { createBlock, mergeBlock, t } from '../../../utils';

export type ICarousel = IBlockData<
    {
        align?: string;
        'background-color'?: string;
        'border-radius'?: string;
        'icon-width'?: string;
        'left-icon'?: string;
        'right-icon'?: string;
        'tb-border'?: string;
        'tb-border-radius'?: string;
        'tb-hover-border-color'?: string;
        'tb-selected-border-color'?: string;
        'tb-width'?: string;
        thumbnails?: string;
    },
    {
        images: Array<{
            src: string;
            href?: string;
            'thumbnails-src'?: string;
            title?: string;
            rel?: string;
            alt?: string;
        }>;
    }
>;

export const Carousel = createBlock<ICarousel>({
    get name() {
        return t('Carousel');
    },
    type: BasicType.CAROUSEL,
    create: (payload: any) => {
        const defaultData: ICarousel = {
            type: BasicType.CAROUSEL,
            data: {
                value: {
                    images: [
                        {
                            src: getImg('IMAGE_15'),
                        },
                        {
                            src: getImg('IMAGE_16'),
                        },
                        {
                            src: getImg('IMAGE_17'),
                        },
                    ],
                },
            },
            attributes: {
                align: 'center',
                'left-icon': 'https://i.imgur.com/xTh3hln.png',
                'right-icon': 'https://i.imgur.com/os7o9kz.png',
                'icon-width': '44px',
                thumbnails: 'visible',
            },
            children: [],
        };
        return mergeBlock(defaultData, payload);
    },
    validParentType: [BasicType.COLUMN],

    render(params: any) {
        const { data } = params;
        const carouselImages = (data).data.value.images
            .map((image: any) => {
                const imageAttributeStr = Object.keys(image)
                    .filter((key) => key !== 'content' && image[key as keyof typeof image] !== '') // filter att=""
                    .map((key) => `${key}="${image[key as keyof typeof image]}"`)
                    .join(' ');
                return `
      <mj-carousel-image ${imageAttributeStr} />
      `;
            })
            .join('\n');
        return <BasicBlock params={params} tag="mj-carousel">{carouselImages}</BasicBlock>;
    },
});
